import React from 'react';

//helpers
import {styleable} from '../../decorators';

//styled-components
import {Circle, Spinner} from './styles';

const SpinnerComponent = ({center, centerX, centerY, centerAbs, color, size = '2rem'}) => (
  <Spinner data-testid="spinner" className="spinner" role="alert" aria-busy="true" aria-label="Loading">
    <Circle
      center={center}
      centerX={centerX}
      centerY={centerY}
      centerAbs={centerAbs}
      color={color}
      size={typeof size === 'number' ? `${size}px` : size}
    />
  </Spinner>
);

export default styleable(SpinnerComponent);
